export class MeetingError extends Error {
  constructor(
    message: string,
    public readonly code: string
  ) {
    super(message)
    this.name = 'MeetingError'
  }
}

export class MeetingPreparationError extends MeetingError {
  constructor(reason: string) {
    super(`Failed to prepare meeting: ${reason}`, 'MEETING_PREPARATION_FAILED')
  }
}
